<template>
  <div class="content-ser">
    <div class="content-page" v-html="contentInfo.content">
    </div>
  </div>
</template>
<script>
import {getArticleDetails} from "@/api/api";

export default {
  data() {
    return {
      contentInfo: {}
    }
  },
  mounted() {
    this.getArticleDetailsInfo()
  },
  methods: {
    getArticleDetailsInfo() {
      let id = 44
      getArticleDetails(id).then(res => {
        this.contentInfo = res.data;
      }).catch(() => {
        // 这里不用再处理错误，错误已经在拦截器里处理了
      });
    }
  }
}
</script>

<style scoped>
.content-ser {
  min-width: 98%;
  height: 80%;
  margin: 40px 20px;
  background: #fff;
  border-radius: 16px;
  overflow-y: scroll;
}

.content-page {
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: start;
  text-align: left;
}
</style>
